import React, { useState } from 'react';
import { Segment, Table } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import fileSortingComparator from '@utils/fileSortingComparator';
import styles from './FilesTable.module.scss';
import UploadedFileRow from './UploadedFileRow';
import UploadVersion from '../UploadVersion';

type Props = {
  files: File[];
  onDelete: (index: number) => void;
};

function FilesTable({ files, onDelete }: Props) {
  const { t } = useTranslation();
  const [, setDeletedFile] = useState<File>();

  if (files.length === 0) {
    return null;
  }

  const onDeleteHandler = (index: number, file: File) => {
    setDeletedFile(file);
    onDelete(index);
  };

  const sortedFiles = files.sort(fileSortingComparator);

  return (
    <>
      <Segment className={styles.scrollable}>
        <Table selectable basic className={styles.filesTableHeader}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t('upload.file.name')}</Table.HeaderCell>
              <Table.HeaderCell className={styles.fileTypeColumn}>
                {t('upload.file.type')}
              </Table.HeaderCell>
              <Table.HeaderCell className={styles.deleteColumn} />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {sortedFiles.map((file, index) => (
              <UploadedFileRow
                file={file}
                index={index}
                onDelete={onDeleteHandler}
                key={file.name + file.lastModified}
              />
            ))}
          </Table.Body>
        </Table>
      </Segment>
      {sortedFiles.length > 0 && <UploadVersion inspectionSummaryFileName={sortedFiles[0].name} />}
    </>
  );
}

export default FilesTable;
